<pdf-shy-button
  primaryToolbarId="zoomOut"
  class="zoomOut"
  title="Zoom Out"
  l10nid="zoom_out"
  l10nLabel="zoom_out_label"
  eventBusName="zoomout"
  [cssClass]="showZoomButtons | responsiveCSSClass : 'always-visible'"
  [order]="1500"
  image="<svg style='width: 24px; height: 24px' viewBox='0 0 24 24'><path fill='currentColor' d='M19,13H5V11H19V13Z' /></svg>"
>
</pdf-shy-button>
